import { PageService } from '@bds/core';
import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthorizeService } from '@bds/auth';

@Component({
    selector: 'app-home-screen',
    templateUrl: './home-screen.component.html',
    styleUrls: ['./home-screen.component.scss'],
})
export class HomeScreenComponent implements AfterViewInit {
    reportId = '';
    workspaceId = '';
    isAuthenticated: Observable<boolean>;
    buttonActive = false;

    constructor(
        public pageService: PageService,
        public readonly authorizeService: AuthorizeService,
    ) {
        pageService.setHeader('Home', true);
        this.isAuthenticated = authorizeService.isAuthenticated();
    }

    @ViewChild('reportContainer', { static: false }) reportContainer!: ElementRef;
    isLoaded = false;

    ngAfterViewInit() {
        this.checkIfLoaded();
    }

    checkIfLoaded(): void {
        const interval = setInterval(() => {
            if (this.reportContainer['isEmbedded']) {
                this.isLoaded = true;
                clearInterval(interval);
            }
        }, 500);
    }
}
